var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"loading-container"},[_c('div',{staticClass:"loading-mask"}),_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-content"},[_c('div',{staticClass:"loading-animate"})])
}]

export { render, staticRenderFns }